import Base from '../../../ts/_base';
import ScreenRender from '../templates/multi-level-slide-menu/multi-level-slide-screen-client.jade';

export default class slideScreen extends Base {

    public headerTitle: string;
    public id: string;
    private content: string;
    public isRoot: boolean;
    private sliderId: string;
    
    constructor(headerTitle: string, template: (data?: any) => string) {
        super();
        this.headerTitle = headerTitle;
        this.id = (Math.random() * Math.pow(10, 7)).toFixed().toString();
        this.content = template();
        if(!headerTitle) this.isRoot = true;
    }

    getAnchorAttributes() {
        return {
            "href": `#slider-${this.sliderId}-${this.id}`,
            "data-slider": this.sliderId,
            "data-action": `navigate`,
            "data-screen": `screen-${this.id}`
        };
    }

    attachToAnchorElm(elm: HTMLElement): void {
        if(!elm) {
            this.showWarn("You attaching a slide screen to a non existent anchor elm");
            return;
        }
        Object.entries(this.getAnchorAttributes()).forEach(([key, val]) => {
            elm.setAttribute(key, val);
        })
    }

    checkAttachedToSlider(): void {
        if(!this.sliderId)
            throw new Error("Can't use an unattached slide screen");
    }

    attachToSlider(sliderId: string): void {
        this.sliderId = sliderId;
    }

    render(): string {
        return ScreenRender({screen: this});
    }

}